import { Component, Input } from '@angular/core';

import { DepartmentModel } from '../../../../../../../reducers/orm/department/department.model';
import { LocationModel } from '../../../../../../../reducers/orm/location/location.model';

@Component({
  standalone: false,
  selector: 'location-info',
  templateUrl: './location-info.component.html',
})
export class LocationInfoComponent {
  @Input()
  locations: { [id: string]: LocationModel };
  @Input()
  department: DepartmentModel;

  location = '';

  ngOnChanges() {
    this.location = this.getLocation();
  }

  getLocation() {
    if (this.locations && this.department) {
      const loc = this.locations[this.department.location_id];

      return loc ? loc.name : '';
    } else {
      return '';
    }
  }
}
